module.exports = __webpack_public_path__ + "02_very_short_brown.833a6479.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/02_very_short_brown.png
// module id = VLJ5
// module chunks = 0